"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedMeasurementResponse = void 0;
const common_interfaces_1 = require("../../common-interfaces");
exports.mockedMeasurementResponse = {
  id: 1,
  weight: 10,
  volumeWeight: 10,
  width: 10,
  height: 10,
  depth: 10,
  unit: common_interfaces_1.Unit.cm
};